import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuth } from '../helpers/auth';

const PrivateRoute = () => {
  const location = useLocation();

  return isAuth() ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute